var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{staticClass:"send-code",attrs:{"type":_vm.type,"disabled":_vm.disabled || _vm.busy || (_vm.seconds < _vm.time)},on:{"click":_vm.sendCode}},[_vm._v(" "+_vm._s(_vm.sendText)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }